import React from 'react';
import { useSelector } from 'react-redux';

// Packages
import { Button, Flex, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {	
	const navigate = useNavigate();

	const { global_data } = useSelector(state => state.global);

	const handleBackHome = () => {
		navigate('/');
	}

	return (
		<Flex vertical align='center' justify='center' style={{ height: '90vh' }}>
			<Result
				status='404'
				title='404'
				subTitle={global_data?.utils?.notFoundPageMsg}
				extra={<Button type='primary' onClick={handleBackHome}>{global_data?.actionButtons?.back}</Button>}
			/>
		</Flex>
	)
}

export default NotFound;
